"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import Api from "../api/api";
import { Flash } from "../components/flash";
import WaitingSpinner from "../components/waiting_spinner";
class RemoveFromWaiting extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      removingFromWaiting: false
    });
    __publicField(this, "removeButton", () => {
      return /* @__PURE__ */ jsx(
        "button",
        {
          className: "button--caution remove-from-waiting__button",
          onClick: this.removeFromWaiting,
          children: "Remove from Waiting"
        }
      );
    });
    __publicField(this, "removeFromWaiting", () => {
      this.setState({ removingFromWaiting: true });
      Api.ExceptionedItems.clearActiveItem(this.props.itemId).then(() => {
        this.setState({ removingFromWaiting: false });
        this.props.onComplete();
        Flash.success("Item Successfully Removed From Waiting!");
      }).catch(() => this.setState({ removingFromWaiting: false }));
    });
  }
  render() {
    return /* @__PURE__ */ jsx(
      WaitingSpinner,
      {
        "data-component": "RemoveFromWaiting",
        when: this.state.removingFromWaiting,
        children: /* @__PURE__ */ jsxs("div", { className: "alert-box  secondary", children: [
          /* @__PURE__ */ jsx("div", { className: "row", children: "It looks like you've sent a message on an invoice that has already been processed or approved. Do you want to remove it from the waiting queue?\xA0" }),
          /* @__PURE__ */ jsxs("div", { className: "row", children: [
            " ",
            this.removeButton()
          ] })
        ] })
      }
    );
  }
}
export default RemoveFromWaiting;
